import { h, FunctionComponent } from 'preact';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { UpliftIcons } from 'up-ops-web-shared-components';
import * as styles from '~src/styles/domains/common/components/inputs.module.scss';
import { InputGroupProps } from '../types/forms';
import InfoTooltip from './InfoTooltip';
import Label from './Label';
import SecureInput from './SecureInput';

/**
  Usage: A <input> with css class, label
*/
const SecureInputGroup: FunctionComponent<InputGroupProps> = ({
  input,
  id,
  page,
  state,
  reduxActions,
  groupType,
  extras,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onChangeHandler = () => {
    return (e: any) => {
      dispatch(
        reduxActions.updateInputValue({
          name: id,
          value: e.target.value,
        }),
      );
    };
  };

  const inputProps = {
    id: id,
    className: 'form-control',
    onChangeHandler: onChangeHandler(),
    ...input,
    type: groupType ? groupType : 'text',
    currencyConfig: extras?.includes('currencyConfig')
      ? t('common:defaultCurrencyConfig', { returnObjects: true })
      : undefined,
    value: '',
  };

  return state.isVisible !== false ? (
    <div
      id={`group-${id}`}
      className={`form-group ${
        state.isValid !== null && state.isValid === false ? 'has-error' : ''
      }`}
    >
      <Label
        label={input.label}
        id={id}
        isValid={state.isValid}
        errorMessage={state.errorMessage}
        showRequiredIcon={state.showRequiredIcon}
      />
      {input.tooltip && (
        <InfoTooltip id={`${id}-tooltip`}>
          {id === 'card-info-ccv' ? (
            <div className={styles['ccv-tooltip-content']}>
              <UpliftIcons.CreditCard />
              <Trans
                i18nKey='accept:inputs.card-info-ccv.tooltip'
                t={t}
                components={[<UpliftIcons.CreditCard />]}
              />
            </div>
          ) : (
            <Trans t={t} i18nKey={`${page}:inputs.${id}.tooltip`} />
          )}
        </InfoTooltip>
      )}
      <SecureInput {...inputProps} />
    </div>
  ) : null;
};

export default SecureInputGroup;
